import { axiosInstance } from './axios.instance';
import { ENDPOINT_BASE_URL } from '../constants';

export class BaseApi {
  httpClient;
  baseUrl = ENDPOINT_BASE_URL;

  constructor() {
    this.httpClient = axiosInstance;
  }

  url(path: string) {
    return `${this.baseUrl}${path}`;
  }
}
